import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';
import { startDirection } from 'app/styles/selectors/markup';
import RGBA from 'app/styles/rgbToRgbaConverter';

const { widthSmall, widthMedium } = breakpoints;
const S = {};

S.CardsHolder = styled.section`
  label: CardsHolder;

  padding-bottom: 2rem;
  background-image: linear-gradient(
    to bottom,
    var(--colors-white),
    ${RGBA('--colors-silver', 0.3)}
  );

  @media (${widthSmall}) {
    padding-bottom: 3rem;
  }
`;

S.CardsHolder.Title = styled.h2`
  label: Title;

  text-align: center;
  margin-bottom: 2rem;
`;

S.CardsHolder.Feed = styled.div`
  label: Feed;

  display: flex;
  justify-content: center;
  overflow-x: hidden;
`;

S.Card = {};

S.Card.Image = styled.img`
  label: Image;

  display: block;
  position: absolute;
  top: 0;
  ${startDirection}: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
`;

S.Card.Thumbnail = styled.div`
  label: Thumbnail;

  position: relative;
  width: 100%;
  padding-top: 150%;
`;

S.SeriesCard = styled.div`
  label: SeriesCard;

  --flexBasis: 38.619%;
  padding: 0 0.36875rem;
  flex: 0 0 var(--flexBasis);
  max-width: var(--flexBasis);

  @media (${widthSmall}) {
    --flexBasis: 18.859%;
  }

  @media (${widthMedium}) {
    --flexBasis: 13.755%;
    padding: 0 0.5rem;
    max-width: 12.25rem;
  }
`;

export default S;
